import * as monaco from 'monaco-editor';

let action = {
    // An unique identifier of the contributed action.
    id: 'copy-selections',

    // A label of the action that will be presented to the user.
    label: 'Copy Selections',

    // An optional array of keybindings for the action.
    keybindings: [
        monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_D
    ],

    // A precondition for this action.
    precondition: null,

    // A rule to evaluate on top of the precondition in order to dispatch the keybindings.
    keybindingContext: null,

    contextMenuGroupId: 'navigation',

    contextMenuOrder: 1.5,

    // Method that will be executed when the action is triggered.
    // @param editor The editor instance is passed in as a convinience
    run: function (ed) {

        let selection = ed.getSelection();
        let position = ed.getPosition();

        let text = ed.getValue();
        let lines = text.split("\n");


        if (selection.startLineNumber === selection.endLineNumber && selection.startColumn === selection.endColumn) {
            //如果没有选择，复制当前行的内容。
            let line = lines[position.lineNumber - 1];

            //追加这一行
            lines.splice(position.lineNumber, 0, line)
            ed.setValue(lines.join("\n"));
            //设置新的光标位置
            ed.setPosition({column: position.column, lineNumber: position.lineNumber + 1});


        } else {
            //如果有选择，复制选中的文字。
            let selectionText = ed.getModel().getValueInRange(selection)
            //默认是从左往右，从上往下选取
            let headPosition = {lineNumber: selection.startLineNumber, column: selection.startColumn}
            let tailPosition = {lineNumber: selection.endLineNumber, column: selection.endColumn}
            //这些情况是从右往左，从下往上选取的。
            if (selection.startLineNumber === selection.endLineNumber) {
                if (selection.startColumn > selection.endColumn) {
                    headPosition = {lineNumber: selection.endLineNumber, column: selection.endColumn}
                    tailPosition = {lineNumber: selection.startLineNumber, column: selection.startColumn}
                }
            } else if (selection.startLineNumber > selection.endLineNumber) {
                headPosition = {lineNumber: selection.endtLineNumber, column: selection.endColumn}
                tailPosition = {lineNumber: selection.startLineNumber, column: selection.startColumn}
            }


            let line = lines[tailPosition.lineNumber - 1];
            line = line.substr(0, tailPosition.column - 1) + selectionText + line.substr(tailPosition.column - 1)

            //替换tailPosition这一行
            lines.splice(tailPosition.lineNumber - 1, 1, line)

            ed.setValue(lines.join("\n"));


            let cursorPosition = null;

            //选取内容没有换行。
            if (headPosition.lineNumber === tailPosition.lineNumber) {
                //设置新的光标位置
                cursorPosition = {
                    column: tailPosition.column + (tailPosition.column - headPosition.column),
                    lineNumber: tailPosition.lineNumber
                }


            } else {
                //设置新的光标位置
                cursorPosition = {
                    column: tailPosition.column,
                    lineNumber: tailPosition.lineNumber + (tailPosition.lineNumber - headPosition.lineNumber)
                };
            }

            let newSelection = {
                startLineNumber: tailPosition.lineNumber,
                startColumn: tailPosition.column,
                endLineNumber: cursorPosition.lineNumber,
                endColumn: cursorPosition.column
            }

            //设置新的光标位置
            ed.setPosition(cursorPosition);
            //设置新的选取范围
            ed.setSelection(newSelection);
        }

    }
};

export default action;


// WEBPACK FOOTER //
// ./src/action/ActionCtrlD.js